
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.8024 15.7584L14.5107 15.0259C14.3632 14.6542 14.134 14.3209 13.8407 14.0492L13.7874 14C13.3257 13.5717 12.719 13.3334 12.089 13.3334H7.9107C7.2807 13.3334 6.67403 13.5717 6.21153 13.9992L6.1582 14.0492C5.86487 14.3209 5.63653 14.6542 5.4882 15.0259L5.19653 15.7584","stroke":"#4A81F7","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.0623 6.20596C13.2014 7.34499 13.2014 9.19172 12.0623 10.3308C10.9233 11.4698 9.07656 11.4698 7.93753 10.3308C6.79849 9.19172 6.79849 7.34499 7.93753 6.20596C9.07656 5.06693 10.9233 5.06693 12.0623 6.20596","stroke":"#4A81F7","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15.3033 4.6967C18.2322 7.62563 18.2322 12.3744 15.3033 15.3033C12.3744 18.2322 7.62562 18.2322 4.6967 15.3033C1.76777 12.3743 1.76777 7.62562 4.6967 4.6967C7.62563 1.76777 12.3744 1.76777 15.3033 4.6967","stroke":"#4A81F7","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    